import { Component } from '@angular/core';

import { HeaderBaseComponent } from '@accuservpro/xplat/features';

@Component({
    selector: 'accuservpro-header',
    templateUrl: 'header.component.html',
    standalone: false
})
export class HeaderComponent extends HeaderBaseComponent {}
